import React, { useContext } from "react";
import { InitialDataContext } from "context/InitialDataContext";

const useData = () => {
  return useContext(InitialDataContext);
};

export default useData;
